import React, { FC } from 'react';
import styled from 'styled-components';
import GlobalHeader from '@blocs.global-header';
import { WindowWidthContext } from '@minecraft.utils';
import appConfig from 'config/appConfig';
import { useLocation } from 'react-router';
import Nav from './Nav';

/** Types */
type Props = {
  updater: any;
  widthData?: WindowWidthContext.WidthData;
};

/** Styled Components */
const FullWidthHeaderColor = styled.section<{ $color: 'blue' | 'red' }>`
  width: 100%;
  background: ${(props): string => {
    if (props.$color === 'blue') return props.theme.colors.primary.dkBlue1;

    if (props.$color === 'red') return props.theme.colors.accent.red;

    return props.theme.colors.primary.dkBlue1;
  }};
`;

/** Main Component */
const Header: FC<Props> = ({ updater, widthData }) => {
  const route = useLocation();
  const routePath: string = route.pathname;

  return (
    routePath &&
    !routePath.includes('/login-admin') && (
      <FullWidthHeaderColor $color="blue">
        <GlobalHeader
          logoRedirectUrl={appConfig.defaultURL}
          logoImage={`${appConfig.cdnRoot}/images/logos/cn-icon-only-white.svg`}
          logoTitle={appConfig.companyName}
          showDivisionSwitcher
          showAdministrative
          updater={updater}
          widthData={widthData}
          showSettings
        >
          <Nav />
        </GlobalHeader>
      </FullWidthHeaderColor>
    )
  );
};

export default WindowWidthContext.withWidthData(Header);
